// @flow
import * as React from 'react';
import Error from 'next/error';

const ErrorPage = ({ statusCode }: { statusCode: number }) => <Error statusCode={statusCode} />;

ErrorPage.getInitialProps = async ({
  res,
  err
}: {
  err?: { statusCode: number },
  res?: { statusCode: number }
}): Promise<{ statusCode: number }> => {
  const statusCode: number = res?.statusCode || err?.statusCode || 404;
  return { statusCode };
};

export default ErrorPage;
